import React from 'react';
import classNames from 'classnames';

export const LinkButton = ({
  className,
  children,
  onClick,
  bold = false,
  size = 'md',
  color = 'brand',
  hoverColor = 'highlighted',
  activeColor = 'faded-brand',
}) => (
  <button
    type="button"
    className={classNames(
      `cursor-pointer text-${size} text-${color} hover:text-${hoverColor} active:text-${activeColor}`,
      { 'font-bold': bold },
      className
    )}
    onClick={onClick}
  >
    { children }
  </button>
)

export default LinkButton;
